// react
// components
import React from "react";

import toEmployeeURL from "../../../utils/URLs/Employee";

import Avatar from "../../Avatar";
import Link from "../../Link";
import Typography from "../../Text";

type UserBlockProps = {
	id?: string;
	name?: string;
};

const UserBlock = ({ id, name }: UserBlockProps) => {
	return (
		<div className="user-block" data-testid={`${name?.replace(/ /g, "-")}-user-block`}>
			<Avatar size={22} label={name} className="user-image circle" id={id} />
			<div className="user-name">
				<Link href={toEmployeeURL(id)} forceHardReload={true}>
					<Typography weight="regular" size="paragraph-3">
						{name}
					</Typography>
				</Link>
			</div>
		</div>
	);
};

export default UserBlock;
